import { render, staticRenderFns } from "./Aneel4.vue?vue&type=template&id=f040ccc6&"
import script from "./Aneel4.vue?vue&type=script&lang=js&"
export * from "./Aneel4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports